import React from 'react';
import styles from "../Settings.module.scss";
import { Span } from "@netapp/bxp-design-system-react";

// Breadcrumbs component to display the scopes in the hierarchy
export const Breadcrumbs = ({ items }) => {
  return (
    <div>
      {items.map((item, index) => {
        const isLastItem = index === items.length - 1;
        return (
          <React.Fragment key={index}>
            <Span>
              {isLastItem ? <strong>{item}</strong> : item}
              {!isLastItem && <Span className={styles["scope-separator"]}>{'>'}</Span>}
            </Span>
          </React.Fragment>
        );
      })}
    </div>
  );
};